import { Authenticated } from "@refinedev/core";
import { Navigate, Outlet, Route, Routes } from "react-router";
import { Login } from "../pages/authentication/Login";
import { Orders } from "../pages/orders/Orders";
import { SyncrosaleLayout } from "../components/layout/SyncrosaleLayout";
import { OrderDetails } from "../pages/order-details/OrderDetails";
import { ShipmentPrices } from "../pages/shipment-prices/listing/ShipmentPrices";
import { ShipmentPriceDetails } from "../pages/shipment-prices/details/ShipmentPriceDetails";
import { Maintenance } from "../pages/maintenance/Maintenance";

const SyncrosaleRouter = () => {
  return (
    <Routes>
      <Route
        element={
          <Authenticated
            key="authenticated-inner"
            fallback={<Navigate to="/login" replace={true} />}
          >
            <SyncrosaleLayout>
              <Outlet />
            </SyncrosaleLayout>
          </Authenticated>
        }
      >
        <Route index element={<Navigate to="/orders" />} />
        <Route path="orders">
          <Route index element={<Orders />} />
          <Route path=":orderId" element={<OrderDetails />} />
        </Route>
        <Route path="shipment-prices">
          <Route index element={<ShipmentPrices />} />
          <Route
            path="edit/:countryId/:carrierId/:serviceId"
            element={<ShipmentPriceDetails />}
          />
        </Route>
      </Route>
      <Route path="/maintenance" element={<Maintenance />} />

      <Route
        element={
          <Authenticated key="authenticated-outer" fallback={<Outlet />}>
            <Navigate to="/" replace={true} />
          </Authenticated>
        }
      >
        <Route path="/login" element={<Login />} />
      </Route>
    </Routes>
  );
};

export default SyncrosaleRouter;
